/* PA · interacción mínima: aparición al hacer scroll y paquetes que mueven el selector nativo de Horizon. */
(() => {
  const io = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
    entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -8% 0px' }) : null;
  const watch = (root = document) => root.querySelectorAll('.pa-reveal:not(.is-in)').forEach((el) => (io ? io.observe(el) : el.classList.add('is-in')));

  /* Paquetes: cada opción hace clic en el radio real del selector de Horizon,
     así el precio, la variante del botón y la barra fija los sigue moviendo el tema. */
  const syncPacks = (picker) => {
    const scope = picker.closest('.shopify-section') || document;
    const checked = scope.querySelector('variant-picker input[type="radio"]:checked, variant-picker select');
    const current = checked ? (checked.tagName === 'SELECT' ? checked.value : checked.value) : null;
    picker.querySelectorAll('.pa-packs__opt').forEach((opt) => opt.setAttribute('aria-checked', String(opt.dataset.value === current)));
  };
  const initPacks = (root = document) => root.querySelectorAll('[data-pa-packs]').forEach((picker) => {
    if (picker.dataset.ready) { syncPacks(picker); return; }
    picker.dataset.ready = '1';
    picker.addEventListener('click', (ev) => {
      const opt = ev.target.closest('.pa-packs__opt');
      if (!opt) return;
      const scope = picker.closest('.shopify-section') || document;
      const radio = [...scope.querySelectorAll('variant-picker input[type="radio"]')].find((r) => r.value === opt.dataset.value);
      if (radio && !radio.checked) radio.click();
      picker.querySelectorAll('.pa-packs__opt').forEach((o) => o.setAttribute('aria-checked', String(o === opt)));
    });
    picker.addEventListener('keydown', (ev) => {
      if (!['ArrowDown', 'ArrowUp', 'ArrowRight', 'ArrowLeft'].includes(ev.key)) return;
      const opts = [...picker.querySelectorAll('.pa-packs__opt')];
      const i = opts.indexOf(document.activeElement);
      if (i < 0) return;
      ev.preventDefault();
      const next = opts[(i + (ev.key === 'ArrowDown' || ev.key === 'ArrowRight' ? 1 : opts.length - 1)) % opts.length];
      next.focus(); next.click();
    });
    syncPacks(picker);
  });

  const boot = () => { watch(); initPacks(); };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', boot) : boot();
  document.addEventListener('change', (e) => { if (e.target.closest('variant-picker')) document.querySelectorAll('[data-pa-packs]').forEach(syncPacks); });
  document.addEventListener('shopify:section:load', (e) => { watch(e.target); initPacks(e.target); });
  /* Horizon vuelve a pintar la ficha al cambiar de variante */
  new MutationObserver(() => initPacks()).observe(document.body, { childList: true, subtree: true });
})();
